import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/lib/auth";
import LoginPage from "@/pages/LoginPage";
import DashboardPage from "@/pages/DashboardPage";
import ModulePage from "@/pages/ModulePage";
import CertificationPage from "@/pages/CertificationPage";
import SearchPage from "@/pages/SearchPage";
import AdminPage from "@/pages/AdminPage";
import PromotionPage from "@/pages/PromotionPage";
import VerifyPage from "@/pages/VerifyPage";
import ResourcesPage from "@/pages/ResourcesPage";
import Layout from "@/components/Layout";
import { Toaster } from "@/components/ui/sonner";

function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#f8fafc]">
        <div className="text-slate-400 font-body text-sm tracking-wider uppercase">Loading...</div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function AppRoutes() {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#f8fafc]">
        <div className="text-slate-400 font-body text-sm tracking-wider uppercase">Loading...</div>
      </div>
    );
  }

  return (
    <Routes>
      {/* Public verification routes - no auth required */}
      <Route path="/verify" element={<VerifyPage />} />
      <Route path="/verify/:verificationId" element={<VerifyPage />} />
      
      <Route path="/login" element={user ? <Navigate to="/" replace /> : <LoginPage />} />
      <Route
        path="/"
        element={
          <ProtectedRoute>
            <Layout />
          </ProtectedRoute>
        }
      >
        <Route index element={<DashboardPage />} />
        <Route path="modules/:moduleId" element={<ModulePage />} />
        <Route path="certification" element={<CertificationPage />} />
        <Route path="search" element={<SearchPage />} />
        <Route path="resources" element={<ResourcesPage />} />
        <Route path="progression" element={<PromotionPage />} />
        <Route path="admin" element={<AdminPage />} />
      </Route>
    </Routes>
  );
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <AppRoutes />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
App;
